import type { GenericAttachment } from '@/styles/GenericAttachmentsSection';
import { uploadEntityAttachments, fetchEntityAttachments, deleteAttachment } from '@/lib/entity-attachments';

// Gantt (schedule task) attachments: the shared implementation
// (lib/entity-attachments.ts) -- this file only names the entity type.
export type ScheduleFileAttachment = GenericAttachment;

export function uploadScheduleTaskAttachments(taskId: string | undefined, files: File[], companyId: string, userId: string): Promise<ScheduleFileAttachment[]> {
  return uploadEntityAttachments('schedule_task', taskId, files, companyId, userId);
}

export function deleteScheduleTaskAttachment(attachmentId: string, userId: string | undefined): Promise<boolean> {
  return deleteAttachment(attachmentId, userId);
}

export function fetchScheduleTaskAttachments(taskId: string): Promise<ScheduleFileAttachment[]> {
  return fetchEntityAttachments('schedule_task', taskId);
}
